import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { INote } from '../interface/notes';

interface IFetchNoteDetail {
  id?: string;
  relations?: string[];
}
export const useFetchNoteDetail = (params: IFetchNoteDetail) => {
  const { id, ...queryParams } = params;
  const queryString = Object.keys(queryParams)?.length
    ? toQueryString(queryParams as QueryParamObject)
    : null;
  const noteDetailUrl = `${API_URLS.NOTES_LIST}/${id}`;
  const url = queryString ? `${noteDetailUrl}?${queryString}` : noteDetailUrl;
  const query = useQuery<INote, Error>({
    queryKey: ['notes-details', id],
    queryFn: async () => {
      const response = await get(url);
      return response;
    },
    enabled: !!id,
  });

  return query;
};
